import { Channel } from './Channel';
import { DynamicFlatNode } from './DynamicFlatNode.class';
import { TreeEntityType } from './enum/TreeEntityType';
import type { SharedDTO } from './interfaces/shared-dto.interface';

export interface IChannelGroup extends SharedDTO {
  /**
   *
   */
  channels: Channel[];
}

export class ChannelGroup implements IChannelGroup {
  /**
   *
   */
  channels: Channel[] = [];
  /**
   *
   */
  identifier!: string;
  /**
   *
   */
  parentIdentifier!: string;
  /**
   *
   */
  name!: string;
  /**
   *
   */
  description!: string;
  /**
   *
   * @param args
   */
  constructor(args: Partial<ChannelGroup>) {
    if (args) {
      Object.assign(this, args);
    }
    if (this.channels) {
      this.channels = this.channels.map((c) => new Channel(c));
    }
  }
  /**
   *
   */
  get entity(): IChannelGroup {
    return {
      channels: this.channels,
      identifier: this.identifier,
      parentIdentifier: this.parentIdentifier,
      name: this.name,
      description: this.description,
    };
  }

  /**
   *
   * @returns
   */
  public toDynamicFlatNode() {
    return new DynamicFlatNode({
      entity: this.entity,
      expandable: true,
      isLoading: false,
      id: this.identifier,
      label: this.name,
      level: 4,
      type: TreeEntityType.CHANNEL_GROUP,
    });
  }
}
